import { Text } from '@gluestack-ui/themed'
import React, { FunctionComponent, useState } from 'react'
import { Image, ScrollView, StyleSheet } from 'react-native'
import { SafeAreaView } from 'react-native-safe-area-context'
import { useSelector } from 'react-redux'
import { Button } from '../../components/Button'
import { CloseButton } from '../../components/CloseButton'
import { TextInput } from '../../components/TextInput'
import { i18n } from '../../lib/i18n'
import { menuSelector } from '../../redux/menu/selector'
import { isEmailValid } from '../../services/form/formValidation'
import { theme } from '../../theme'
import { useResetPasswordSendEmail } from './useResetPasswordSendEmail'

const LOGO_HEIGHT = 76

const styles = StyleSheet.create({
  title: {
    fontSize: 30,
    fontWeight: '700',
    lineHeight: 45,
    color: theme.colors.black,
    marginBottom: theme.padding.x3,
  },
  subtitle: {
    color: theme.colors.silverStrong,
    marginBottom: theme.padding.x4,
  },
  input: {
    marginBottom: theme.padding.x3,
  },
  logo: {
    height: LOGO_HEIGHT,
    width: '100%',
    marginBottom: theme.padding.x2,
  },
  container: {
    maxWidth: '100%',
    flex: 1,
    backgroundColor: theme.colors.white,
  },
  scrollview: {
    width: '100%',
    padding: theme.padding.x3,
  },
})

export const ResetPasswordSendEmail: FunctionComponent = () => {
  const menu = useSelector(menuSelector)
  const [email, setEmail] = useState('')
  const { doResetPasswordSendEmail, loading } = useResetPasswordSendEmail()

  const logoUri = menu && menu.header && menu.header.image

  const handleResetPasswordSendEmail = () => {
    doResetPasswordSendEmail(email)
  }

  return (
    <SafeAreaView style={[styles.container]}>
      <ScrollView style={styles.scrollview}>
        {!!logoUri && <Image style={styles.logo} source={{ uri: logoUri }} resizeMode="contain" />}
        <CloseButton />
        <Text style={styles.title}>{i18n.t('resetPasswordSendEmail.title')}</Text>
        <Text style={styles.subtitle}>{i18n.t('resetPasswordSendEmail.subtitle')}</Text>
        <TextInput
          label={i18n.t('resetPasswordSendEmail.email.label')}
          placeholder={i18n.t('resetPasswordSendEmail.email.placeholder')}
          value={email}
          isMail
          autoCapitalize="none"
          keyboardType="email-address"
          autoComplete="email"
          autoCorrect={false}
          onValueChanged={text => setEmail(text)}
          style={styles.input}
        />
        <Button
          onPress={handleResetPasswordSendEmail}
          label={i18n.t('resetPasswordSendEmail.sendResetLink')}
          style={{ backgroundColor: theme.colors.lightBlue, marginBottom: theme.padding.x2 }}
          iconName="mail"
          loading={loading}
          disabled={!isEmailValid(email)}
        />
      </ScrollView>
    </SafeAreaView>
  )
}
